/*
adjust hero margin based on menu height
 */

(function ($, window) {

	let win = $(window);

	win.on("load", () => {

		adjust_margin();

		// execute on screen resize
		win.on('resize.hero-margin', $.debounce(250, adjust_margin));
	});

	let adjust_margin = function () {
		let hero = $('.container-fluid.hero');
		let menu = $('nav.primary.navbar');

		if (hero.length === 1 && menu.length === 1) {
			// only do stuff on desktop
			if (win.outerWidth() >= 'NALU__BOOTSTRAP__BREAKPOINT__NALU') {

				let heroMargin = hero.css('margin-top');
				let menuHeight = menu.outerHeight();

				if (heroMargin !== menuHeight)
					hero.css('margin-top', menuHeight)

			} else
				hero.css('margin-top', 0);

		}
	}
})(jQuery, window);
